<template>
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="6">
            <!-- <el-form-item label="展厅名称 :" prop="name">
              <el-select v-model="form.name" placeholder="请选择">
                <el-option v-for="(item, index) in recruitList" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="选择日期 :" prop="date">
              <el-date-picker v-model="form.date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="请选择"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="com-head-search-btns">
        <el-button type="primary" @click="getExhibitionDetailList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <div v-loading="tableLoading" class="table-wrapper com-list-content">
      <template>
        <div class="header">
          <span class="span1" v-for="(item, index) in timeList" :key="index">{{item}}</span>
        </div>
        <div class="area" v-for="(it1, key1, dx1) in tableList" :key="dx1">
          <span class="date">{{key1}}</span>
          <div class="appoint-wrapper" v-for="(it2, dx2) in it1" :key="dx2">
            <span class="span1" v-if="it2 == null"></span>
            <span class="span1" :class="{'active': it2 && it2.isExplain == 1, 'disabled':  it2 && it2.isApoint == 0, 'c-p':it2 && it2.isApoint == 1}" @click="setExplain(it2)" v-else>{{it2 && it2.name}}</span>
          </div>
        </div>
      </template>

      <!-- <el-empty v-else description="暂无数据"></el-empty> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        date: ''
      },
      timeList: [],
      recruitList: [],
      tableList: [],
      tableLoading: true
    }
  },

  mounted() {
    this.getExhibitionDetailList()

    window.addEventListener('keyup',this.keydown)
    // this.showRecruit()
    // this.getDropdownValue()
  },
  methods: {
    getExhibitionDetailList() {
      this.tableLoading = true
      this.tableList = []
      this.$api.volunteer.getExhibitionDetailList({
        ...this.form
      }).then(res => {
        this.tableLoading = false

        if (res.success) {
          let results = res.result, arrList = []
          if (results && results.length > 0) {
            if (results[0].id) {
              let arr = []
              for (let m = 0; m < results.length; m++) {
                if (arr.indexOf(results[m].appointmentTime) == -1) {
                  arr.push(results[m].appointmentTime)
                }
              }
              let tempObj = {}
              results.map((item, index) => {
                if (tempObj[item.appointmentDate] != null) {
                  tempObj[item.appointmentDate].push(item)
                } else {
                  let every = []
                  every.push(item)
                  tempObj[item.appointmentDate] = every
                }
                // this.$set(item, "appointList", JSON.parse(JSON.stringify(appointList)));
                // arr.push([])
                // if (index == 0) {
                //   this.tableHeaderList.unshift('预约情况表')
                //   this.tableHeaderList.push(item.appointmentDate)
                // } 
                // else {
                //   arr[index + 1].push(item.appointmentDate)
                // }
                // for (let m = 0; m < results.length; m++) {
                //   if (index == 0) {
                //     if (arr[0].indexOf(results[m].appointmentTime) == -1) {
                //       arr[0].push(results[m].appointmentTime)
                //     }
                //   }
                // }
              })
              // for (let m = 0; m < results.length; m++) {
              //   arr.map((it, dx) => {
              //     if (dx > 0) {
              //       if (it[0] == results[m].appointmentDate) {
              //         if ((dx - 1) == m) {
              //           it.push(results[m])
              //         } else {
              //           it.push('')
              //         }
              //       }
              //     }
              //   })
              // }
              // arr.forEach((item, index) => {
              //   for (let m = 0; m < results.length; m++) {
              //     if (index > 0) {
              //       if ((index - 1) == m) {
              //         item.push({ adultId: results[m].adultId, id: results[m].id, isExplain: results[m].isExplain })
              //       } else {
              //         item.push('')
              //       }
              //     }
              //   }
              // })
              arr.unshift('预约情况表')
              this.timeList = arr
              this.tableList = tempObj
            }
          }

        }
      })
    },

    setExplain(obj) {
      if (!obj.name || obj.isExplain == 1) {
        return
      }
      this.$common.confirm(
        {
          title: '是否设置为讲解员？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$api.volunteer.setExplain({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('设置成功')
              this.getExhibitionDetailList()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },


    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http.get('/AppointTicket/getSettingTimesList').then(res => {
        if (res.success) {
          let timeList = res.result
          timeList.map(item => {
            this.timeList.push(item.startTime + ':' + item.endTime)
          })

          // this.timeList.unshift('预约情况表')
        } else {
          this.$message.error(res.message)
        }
      })
    },

    // showRecruit() {
    //   this.$api.volunteer.showRecruit().then(res => {
    //     if (res.success) {
    //       this.recruitList = res.result
    //       this.form.name = this.recruitList[0]
    //       this.getExhibitionDetailList()
    //     }
    //   })
    // },

    restList() {
      this.timeList = []
      this.getExhibitionDetailList()
    },

    keydown(event){
      if(event.keyCode == '13'){
        this.getExhibitionDetailList()
      }
    }

  }
}
</script>

<style lang='scss' scoped>
.table-wrapper {
  .flex {
    display: flex;
  }
  .span1 {
    flex: 1;
    display: inline-block;
    box-sizing: border-box;
    height: 100%;
    border-right: 1px solid #606266;
    text-align: center;
    &.c-p {
      cursor: pointer;
      &:hover {
        color: #0590ff;
      }
      &.active {
        background-color: #0590ff;
        color: #fff;
      }
      &.disabled {
        background-color: #e4e7ed;
      }
    }
  }
  .header {
    display: flex;
    box-sizing: border-box;
    height: 30px;
    line-height: 30px;
    border: 1px solid #606266;
    border-right: none;
    border-bottom: none;
  }
  .area {
    display: flex;
    height: 30px;
    box-sizing: border-box;
    line-height: 30px;
    border: 1px solid #606266;
    border-bottom-width: 0;
    &:last-child {
      border-bottom: 1px solid #606266;
    }
    .date {
      flex: 1;
      text-align: center;
      display: inline-block;
      border-right: 1px solid #606266;
    }
    .appoint-wrapper {
      display: flex;
      flex: 1;
      flex-direction: row;
      &:last-child {
        .span1 {
          border: none;
        }
      }
    }
  }
}
</style>